// Disabling the rule to remove keyboard navigation focus ring that ds2 Link element had
/* eslint-disable react/forbid-elements */
import React from 'react';

import { Avatar, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { TopStoryDesktop, TopStoryMobile } from '../../types';

import { TopImpactStoryBadge } from './components/TopImpactStoryBadge';

type Props = {
	trackStoryClick: (url: string) => void;
	story: TopStoryDesktop & TopStoryMobile;
	isMobile?: boolean;
	isCenteredOnMobile?: boolean;
	onStoryFocus?: () => void;
};

export const TopImpactStoryBubble: React.FC<Props> = ({
	story,
	isMobile = false,
	isCenteredOnMobile = false,
	onStoryFocus,
	trackStoryClick,
}) => {
	return (
		<div className="flex shrink-0 flex-col items-center justify-center">
			<div
				className={cn(
					'group relative',
					!isMobile && !story.isDesktopCentered && ['absolute', story.top, story.transform],
				)}
				data-testid="top-impact-story-bubble-wrapper"
			>
				<a
					href={story.url}
					className="relative z-10 block w-[210px] text-center no-underline outline-none lg:w-[180px] xl:w-[210px]"
					onClick={() => trackStoryClick(story.url)}
					aria-label={story.ariaLabel}
					data-testid={`${story.dataTestIdBase}-link`}
					data-qa="top-impact-story-link"
					onFocus={onStoryFocus}
					tabIndex={story.tabIndex}
					aria-hidden={story.ariaHidden}
				>
					<Avatar
						src={story.image}
						alt={story.altText}
						size={210}
						className={cn(
							[
								'object-cover',
								'relative z-10',
								'before:absolute before:inset-x-[-2px] before:inset-y-[4px] before:-top-2 before:bottom-2',
								'before:rounded-full before:content-[""]',
								'before:-z-1 before:bg-[#4AAEFF] before:blur-lg',
								'before:opacity-0 before:transition-opacity before:duration-300 before:will-change-[opacity]',
							],
							{
								'before:opacity-100': isCenteredOnMobile && isMobile,
								'group-focus-within:before:opacity-100 group-hover:before:opacity-100': !isMobile,
							},
						)}
						data-testid={`${story.dataTestIdBase}-image`}
						aria-hidden
					/>

					<TopImpactStoryBadge
						labelTitle={story.labelTitle}
						labelText={story.labelText}
						dataTestId={`${story.dataTestIdBase}-badge`}
						isCenteredOnMobile={isCenteredOnMobile}
						isMobile={isMobile}
					/>

					{!isMobile && (
						<Text
							as="p"
							size="large"
							className="line-clamp-3 min-h-[15svh] pt-11 opacity-0 transition-opacity duration-200 group-focus-within:opacity-100 group-hover:opacity-100"
							data-testid={`${story.dataTestIdBase}-summary`}
						>
							{story.summary}
						</Text>
					)}
				</a>
			</div>
		</div>
	);
};
